export const SUMMARY_TITLE = "Summary"

export const DASHBOARD_TOOLBAR_TITLE = "Document Center"
export const REFRESH_TITLE = "Refresh Document Center"
export const SERVER_FAILED_ERROR_MESSAGE = "Server Failed";